'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Sortable = require('Sortable');

var _Sortable2 = _interopRequireDefault(_Sortable);

var _widget = require('../widget');

var Widget1 = (function (_React$Component) {
    _inherits(Widget1, _React$Component);

    function Widget1() {
        _classCallCheck(this, Widget1);

        _get(Object.getPrototypeOf(Widget1.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Widget1, [{
        key: 'render',
        value: function render() {
            var options = {
                containerClass: 'col-sm-6',
                title: 'WIDGET 1',
                content: _react2['default'].createElement(
                    'div',
                    null,
                    _react2['default'].createElement(
                        'p',
                        null,
                        'Widget Content'
                    )
                )
            };
            return _react2['default'].createElement(_widget.Widget, { options: options });
        }
    }]);

    return Widget1;
})(_react2['default'].Component);

var Widget2 = (function (_React$Component2) {
    _inherits(Widget2, _React$Component2);

    function Widget2() {
        _classCallCheck(this, Widget2);

        _get(Object.getPrototypeOf(Widget2.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Widget2, [{
        key: 'render',
        value: function render() {
            var options = {
                containerClass: 'col-sm-6',
                title: 'WIDGET 2',
                content: _react2['default'].createElement(
                    'div',
                    null,
                    _react2['default'].createElement(
                        'p',
                        null,
                        'Widget Content'
                    )
                )
            };
            return _react2['default'].createElement(_widget.Widget, { options: options });
        }
    }]);

    return Widget2;
})(_react2['default'].Component);

var Widget3 = (function (_React$Component3) {
    _inherits(Widget3, _React$Component3);

    function Widget3() {
        _classCallCheck(this, Widget3);

        _get(Object.getPrototypeOf(Widget3.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Widget3, [{
        key: 'render',
        value: function render() {
            var options = {
                containerClass: 'col-sm-12',
                noheader: true,
                content: _react2['default'].createElement(
                    'div',
                    null,
                    _react2['default'].createElement(
                        'h3',
                        { className: 'widget-title' },
                        'WIDGET WITHOUT HEADER'
                    ),
                    _react2['default'].createElement(
                        'p',
                        null,
                        'Widget Content'
                    )
                )
            };
            return _react2['default'].createElement(_widget.Widget, { options: options });
        }
    }]);

    return Widget3;
})(_react2['default'].Component);

var Widget4 = (function (_React$Component4) {
    _inherits(Widget4, _React$Component4);

    function Widget4() {
        _classCallCheck(this, Widget4);

        _get(Object.getPrototypeOf(Widget4.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Widget4, [{
        key: 'render',
        value: function render() {
            var options = {
                containerClass: 'col-sm-4',
                title: this.props.title,
                content: _react2['default'].createElement(
                    'div',
                    null,
                    _react2['default'].createElement(
                        'p',
                        null,
                        'Widget Content'
                    )
                )
            };
            return _react2['default'].createElement(_widget.Widget, { options: options });
        }
    }]);

    return Widget4;
})(_react2['default'].Component);

var WidgetList = (function (_React$Component5) {
    _inherits(WidgetList, _React$Component5);

    function WidgetList(props) {
        _classCallCheck(this, WidgetList);

        _get(Object.getPrototypeOf(WidgetList.prototype), 'constructor', this).call(this, props);
        this._sortableInstance = null;
    }

    _createClass(WidgetList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var dom = _react2['default'].findDOMNode(this);
            this._sortableInstance = _Sortable2['default'].create(dom, {
                filter: '.widget-content'
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._sortableInstance.destroy();
            this._sortableInstance = null;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'div',
                { className: 'row' },
                _react2['default'].createElement(Widget1, null),
                _react2['default'].createElement(Widget2, null),
                _react2['default'].createElement(Widget3, null),
                _react2['default'].createElement(Widget4, { title: 'widget 5' }),
                _react2['default'].createElement(Widget4, { title: 'widget 6' }),
                _react2['default'].createElement(Widget4, { title: 'widget 7' })
            );
        }
    }]);

    return WidgetList;
})(_react2['default'].Component);

var Dashboard = (function (_React$Component6) {
    _inherits(Dashboard, _React$Component6);

    function Dashboard() {
        _classCallCheck(this, Dashboard);

        _get(Object.getPrototypeOf(Dashboard.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Dashboard, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'div',
                { className: 'container no-heading' },
                _react2['default'].createElement(WidgetList, null)
            );
        }
    }]);

    return Dashboard;
})(_react2['default'].Component);

exports.Dashboard = Dashboard;
//# sourceMappingURL=data:application/json;base64,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